import { useCallback, useEffect, useState } from "react";

export function useChatSidebar() {
	const [isOpen, setIsOpen] = useState(false);

	const toggle = useCallback(() => setIsOpen((prev) => !prev), []);
	const open = useCallback(() => setIsOpen(true), []);
	const close = useCallback(() => setIsOpen(false), []);

	useEffect(() => {
		function handleKeyDown(e: KeyboardEvent) {
			if ((e.metaKey || e.ctrlKey) && e.shiftKey && e.key === "k") {
				e.preventDefault();
				setIsOpen((prev) => !prev);
			}
		}
		document.addEventListener("keydown", handleKeyDown);
		return () => document.removeEventListener("keydown", handleKeyDown);
	}, []);

	return { isOpen, toggle, open, close };
}
